export default {
  dataOutfits: null,
  titleOutfit: null,
  descriptionOutfit: null,
  dataOutfitPage: null,
  outfitCategorys: null,
  outfitDetail: null,
  outfitTitle: '',
}
